import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import modal from '~/components/modal.vue';
import API from '~/api/api.js';
import isButton from '~/components/button.vue';
var Datepicker = void 0;
if (process.browser) {
  Datepicker = require('vuejs-datepicker');
}
export default {
  props: ['openDelivery', 'userData', 'projectInfo'],
  notifications: {
    showLoginError: {
      title: '',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  data: function data() {
    return {
      deliveryDate: '',
      openCurrentEst: false
    };
  },

  methods: {
    showModalCurrent: function showModalCurrent() {
      this.openCurrentEst = true;
    },
    updateEstCurrentDate: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var button, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                button = this.$refs.myBtn;

                if (!(this.deliveryDate === '')) {
                  _context.next = 5;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert Project LeadTime'
                });
                button.enabled();
                return _context.abrupt('return', false);

              case 5:
                _context.next = 7;
                return API.setToken(this.userData.tokenID);

              case 7:
                _context.next = 9;
                return API.putDeliveryDate(this.projectInfo.projectID, this.projectInfo.prodTaskID, this.deliveryDate);

              case 9:
                result = _context.sent;

                if (!(result.data.flag === true)) {
                  _context.next = 14;
                  break;
                }

                window.location.reload();
                _context.next = 17;
                break;

              case 14:
                this.showLoginError({
                  message: result.data.message
                });
                button.enabled();
                return _context.abrupt('return', false);

              case 17:
                button.enabled();

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateEstCurrentDate() {
        return _ref.apply(this, arguments);
      }

      return updateEstCurrentDate;
    }()
  },
  components: {
    modal: modal,
    isButton: isButton,
    Datepicker: Datepicker
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/DeliveryDateComponent.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/DeliveryDateComponent.vue
// module chunks = 2 3